var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"px-0 py-0 mx-auto",attrs:{"cols":"10","lg":"12","md":"12","sm":"12","xl":"12"}},[_c('v-img',{staticClass:"shrink mx-auto",staticStyle:{"cursor":"pointer"},attrs:{"alt":"Logo","contain":"","src":"https://r.mailcomms.io/b2b/logos/light.png","width":"125"},on:{"click":function($event){return _vm.goRoot()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }